module.exports = __webpack_public_path__ + "static/img/goods-info.0100a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amuletj/goods-info.png
// module id = kaHG
// module chunks = 2